/**
 * Theme assets are served directly from the S3 bucket.
 */

export function s3PublicBaseUrl() {
  const path = String(process.env.REACT_APP_S3_PATH || '').trim();
  if (path) {
    return path.endsWith('/') ? path : `${path}/`;
  }

  const bucket = String(process.env.REACT_APP_S3BUCKET_URL || 'https://2023-extramileplay-php.s3.amazonaws.com').replace(/\/$/, '');
  const env = String(process.env.REACT_APP_S3_ENVIRMOENT || 'UAT').replace(/^\/+|\/+$/g, '');
  const folder = String(process.env.REACT_APP_S3_GAME_FOLDER || 'future_india').replace(/^\/+|\/+$/g, '');
  return `${bucket}/${env}/${folder}/`;
}

/** No-op: theme assets resolve directly from S3, not via a backend proxy. */
export function setThemeAssetBaseUrl() {}

/**
 * Build a URL for a theme asset filename stored in the DB/themeset.
 * Passes through values that are already absolute URLs.
 */
export function s3PublicUrl(asset) {
  if (asset == null || asset === '') return '';
  const s = String(asset).trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith('//')) return `https:${s}`;

  const key = s.replace(/^\/+/, '');
  const base = s3PublicBaseUrl();
  if (!base) return '';

  return `${base}${key}`;
}
